import { render, staticRenderFns } from "./GoalCompletion.vue?vue&type=template&id=1c08569e"
import script from "./GoalCompletion.vue?vue&type=script&lang=js"
export * from "./GoalCompletion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports